import Swiper from 'swiper';
import 'swiper/css';

export function init120YearsDivisionsSlider() {
    const sliderElements = document.querySelectorAll('.divisions-120-years-slider');
    
    sliderElements.forEach((sliderElement) => {
        let swiperInstance = null;
        
        const initSwiper = () => {
            if (window.innerWidth < 1024 && !swiperInstance) {
                swiperInstance = new Swiper(sliderElement, {
                    slidesPerView: 1.33,
                    loop: false,
                });
            } else if (window.innerWidth >= 1024 && swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        };
        
        initSwiper();
        
        window.addEventListener('resize', initSwiper);
    });

    init120YearsDivisionOverlayToggle();
}

function init120YearsDivisionOverlayToggle() {
    const divisionItems = document.querySelectorAll('.js-120-years-division-item');
    
    divisionItems.forEach((item) => {
        const hasOverlay = item.dataset.hasOverlay === 'true';
        
        if (!hasOverlay) return;
        
        const overlay = item.querySelector('.js-120-years-division-overlay');
        const title = item.querySelector('.js-120-years-division-title');
        
        if (!overlay || !title) return;
        
        let isOpen = false;
        
        item.addEventListener('click', (e) => {
            const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            
            if (isTouchDevice || window.innerWidth < 1024) {
                if (isOpen && e.target.closest('a')) {
                    return;
                }
                
                e.preventDefault();
                isOpen = !isOpen;
                
                if (isOpen) {
                    overlay.classList.remove('translate-y-full', 'opacity-0');
                    overlay.classList.add('translate-y-0', 'opacity-100');
                    title.classList.add('opacity-0');
                } else {
                    overlay.classList.add('translate-y-full', 'opacity-0');
                    overlay.classList.remove('translate-y-0', 'opacity-100');
                    title.classList.remove('opacity-0');
                }
            }
        });
        
        document.addEventListener('click', (e) => {
            const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            
            if ((isTouchDevice || window.innerWidth < 1024) && isOpen && !item.contains(e.target)) {
                isOpen = false;
                overlay.classList.add('translate-y-full', 'opacity-0');
                overlay.classList.remove('translate-y-0', 'opacity-100');
                title.classList.remove('opacity-0');
            }
        });
    });
}
